module.exports = __webpack_public_path__ + "img/diagnosing.d6e537b2.svg";